type CallbackArgs = unknown[];
type CallbackFn = (...args: CallbackArgs) => void;
type Callbacks<T extends string> = Record<T, Array<CallbackFn>>;

export default class eventEmitter<T extends string> {
    callbacks: Callbacks<T>;
    constructor() {
        this.callbacks = {} as Callbacks<T>;
    }

    on = (event: T, callback: CallbackFn): void => {
        if (event in this.callbacks) {
            this.callbacks[event] = [...this.callbacks[event], callback];
        } else {
            this.callbacks[event] = [callback];
        }
    };

    off = (event: T, callback: CallbackFn): void => {
        if (event in this.callbacks) {
            this.callbacks = {
                ...this.callbacks,
                [event]: this.callbacks[event].filter((cb) => cb !== callback),
            };
        }
    };

    trigger = (event: T, ...args: CallbackArgs): void => {
        if (event in this.callbacks) {
            this.callbacks[event].forEach((callback) => callback.apply(this, args));
        }
    };
}
